import { Box, Divider, Stack, Typography } from '@mui/material';
import { DefinitionGrid, SectionCard, ValueBadge } from '../../../design-system';
import type { SelfProfileWorker } from './model';
import { profileTextValue } from './profileDisplay';

export function EmployeeProfileAffiliations({ worker }: { worker: SelfProfileWorker }) {
  const memberships = [
    ...(worker.primaryJob ? [{ job: worker.primaryJob, isPrimary: true }] : []),
    ...(worker.additionalJobs ?? []).map((job) => ({ job, isPrimary: false })),
  ];

  return <SectionCard title="소속·직무" bodyPadding="standard">
    {memberships.length ? <Stack component="ul" aria-label="소속과 직무" spacing={2} divider={<Divider component="li" role="separator" />} sx={{ m: 0, p: 0, listStyle: 'none' }}>
      {memberships.map(({ job, isPrimary }) => <Box component="li" key={job.id} sx={{ minWidth: 0 }}>
        <Stack direction="row" spacing={1} useFlexGap sx={{ alignItems: 'center', flexWrap: 'wrap', mb: 1.5 }}>
          <Typography component="h3" variant="body2" sx={{ fontWeight: 700, overflowWrap: 'anywhere' }}>
            {profileTextValue(job.supervisoryOrganization?.descriptor) || '조직 미등록'}
          </Typography>
          {!isPrimary && <ValueBadge label="겸직" />}
        </Stack>
        <DefinitionGrid columns={3} emptyValue="미등록" testId={`employee-membership-${isPrimary ? 'primary' : job.id}`} items={[
          { id: 'job-title', label: '직무·직함', value: profileTextValue(job.businessTitle || job.jobProfile?.descriptor || job.descriptor) },
          { id: 'manager', label: '리더', value: profileTextValue(job.manager?.descriptor) },
          { id: 'location', label: '근무지', value: profileTextValue(job.location?.descriptor) },
        ]} />
      </Box>)}
    </Stack> : <Typography variant="body2" color="text.secondary">등록된 소속과 직무가 없습니다.</Typography>}
  </SectionCard>;
}
